module.exports = __webpack_public_path__ + "media/customizations/crystallake/logo-6a5c65930f8bad65494f3763499ad71a.png";